/* House of Ovelle — "Remove set" on the /cart page.

   ovelle.js has a document-level handler for [data-ov-set-remove] that re-renders
   the cart DRAWER after the update. On the cart page that would leave the page's
   own table stale, because the sections it asks for are the drawer's.

   This listener runs in the CAPTURE phase and stops propagation, so on the cart
   page it handles the removal itself and reloads; inside the drawer it bows out
   and lets the ovelle.js handler do its thing. */
(function () {
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('[data-ov-set-remove]');
      if (!btn) return;
      if (btn.closest('cart-drawer')) return; // drawer handler owns this one

      e.preventDefault();
      e.stopPropagation();

      var keys = (btn.dataset.keys || '').split(',').filter(function (k) { return k; });
      if (!keys.length) return;

      var updates = {};
      keys.forEach(function (k) { updates[k] = 0; });

      var card = btn.closest('.ov-set');
      btn.disabled = true;
      if (card) card.classList.add('is-removing');

      fetch(window.routes.cart_update_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () {
          btn.disabled = false;
          if (card) card.classList.remove('is-removing');
        });
    },
    true
  );
})();
